import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import Card from "@mui/material/Card";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
//import { ALL_MEETINGS } from "../queries";
import { useQuery } from "@apollo/client";
import { FIND_SECTION } from "queries";
import bgImage from "assets/images/toimielimet.png";
import { useTranslation } from "react-i18next";
import Proposalspublic from "./Proposalspublic";
import Commentpublic from "./Commentpublic";
import Linkspublic from "./Linkspublic";
//ALL_ORGANS, ALL_COMMENTS, ALL_USERS, ALL_MINUT, ALL_MINUTES, ALL_LINKS, ALL_VOTES, ALL_INITIATIVES, ALL_MUNICIPALITIES, ALL_SECTIONS,  ORGAN_ADDED,  ALL_PROPOSALS
/* eslint-disable react/prop-types */
const Sectionpublic = ({ selectedKunta }) => {
  const [sections, setSections] = useState({});
  const [attach, setAttach] = useState([]);
  const [t] = useTranslation("common");
  //const [selected, setSelected] = useState([]);
  //const [meet, setMeet] = useState();
  //////console.log(setOrgans);

  let section = useParams().id;
  //////console.log(section);
  const sectionssw = useQuery(FIND_SECTION, {
    pollInterval: 100000,
    variables: { id: section },
  });

  useEffect(() => {
    let sectionss = [];
    //let municipalitiess = [];
    if (sectionssw.data) {
      sectionss = sectionssw.data.findSection;
      //setOrgans(organss);
      ////console.log(sectionss);
      //let secs = sectionss.filter((cont) => {
      //return cont.id === section;
      //});
      setSections(sectionss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, []);
  useEffect(() => {
    let sectionss = [];
    //let municipalitiess = [];
    if (sectionssw.data) {
      ////console.log(sectionssw);
      sectionss = sectionssw.data.findSection;
      //setOrgans(organss);
      ////console.log(sectionss);
      //let secs = sectionss.filter((cont) => {
      //return cont.id === section;
      //});
      //////console.log(secs);
      setSections(sectionss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
      let liit = [];
      if (sections.attachments !== undefined) {
        if (sectionss.attachments.length > 0) {
          liit = sectionss.attachments.split("|||||");
        }
        //try {
        //let a = [];
        //a=JSON.parse(JSON.stringify(valitut.attachments));
        // setLiite(a)
        //} catch(e) {
        // alert(e)
        //}
        let liitarr = [];

        for (let i = 0; i < liit.length; i++) {
          let liityhd = liit[i].split("<<<<<<");
          liitarr.push(liityhd);
        }
        setAttach(liitarr);
        ////console.log(liitarr);
      }
    }
  }, [selectedKunta, sectionssw]);
  if (sections) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {" "}
              </MKTypography>
              <Card
                sx={{
                  p: 2,
                  mx: { xs: 2, lg: 3 },
                  mt: -8,
                  mb: 4,
                  backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                    rgba(white.main, 0.8),
                  backdropFilter: "saturate(200%) blur(30px)",
                  boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
              >
                <MKTypography
                  variant="body1"
                  color="black"
                  textAlign="center"
                  px={{ xs: 6, lg: 12 }}
                  mt={1}
                >
                  <table width="100%" align="left">
                    <tr>
                      <td align="left" width="50%">
                        <h2>{sections.header}</h2>
                        <br />
                        {sections.casetext}
                        <br />
                        <br />
                        <b>{t("common.preparer")}</b>: {sections.preparer}
                        <br />
                        <br />
                        <b>{t("common.sectionnumber")}</b>: {sections.caseid}
                        <br />
                        <br />
                        <b>{t("common.proposal")}</b>: {sections.proposalforadecision}
                        <br />
                        <br />
                        <b>{t("common.attachments")}</b>
                        <br />
                        {attach.map((p) => (
                          <>
                            <a href={p[0]}>{p[1]}</a>
                            <br />
                          </>
                        ))}
                        <br />
                        <b>{t("common.municipal")}</b>: {sections.sectionmunicipality}
                        <br />
                        <br />
                        <b>{t("common.agenda")}</b>: {sections.agendaid}
                        <br />
                        <br />
                      </td>
                    </tr>
                  </table>
                </MKTypography>
              </Card>
            </Grid>
          </Container>
        </MKBox>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {" "}
              </MKTypography>
              <Card
                sx={{
                  p: 2,
                  mx: { xs: 2, lg: 3 },
                  mt: -8,
                  mb: 4,
                  backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                    rgba(white.main, 0.8),
                  backdropFilter: "saturate(200%) blur(30px)",
                  boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
              >
                <MKTypography
                  variant="body1"
                  color="black"
                  textAlign="center"
                  px={{ xs: 6, lg: 12 }}
                  mt={1}
                >
                  <Proposalspublic originalProposal={sections.proposalforadecision} />
                </MKTypography>
              </Card>
            </Grid>
          </Container>
        </MKBox>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {" "}
              </MKTypography>
              <Card
                sx={{
                  p: 2,
                  mx: { xs: 2, lg: 3 },
                  mt: -8,
                  mb: 4,
                  backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                    rgba(white.main, 0.8),
                  backdropFilter: "saturate(200%) blur(30px)",
                  boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
              >
                <MKTypography
                  variant="body1"
                  color="black"
                  textAlign="center"
                  px={{ xs: 6, lg: 12 }}
                  mt={1}
                >
                  <Commentpublic />
                </MKTypography>
              </Card>
            </Grid>
          </Container>
        </MKBox>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {" "}
              </MKTypography>
              <Card
                sx={{
                  p: 2,
                  mx: { xs: 2, lg: 3 },
                  mt: -8,
                  mb: 4,
                  backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                    rgba(white.main, 0.8),
                  backdropFilter: "saturate(200%) blur(30px)",
                  boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
              >
                <MKTypography
                  variant="body1"
                  color="black"
                  textAlign="center"
                  px={{ xs: 6, lg: 12 }}
                  mt={1}
                >
                  <Linkspublic />
                </MKTypography>
              </Card>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                Ei asioita
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};

export default Sectionpublic;
